var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconReport = function SvgIconReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    fillRule: "evenodd",
    d: "M4.6 2.4a.6.6 0 0 0-1.2 0V14a.6.6 0 1 0 1.2 0v-3.6h7.362c.183 0 .36 0 .502-.013.141-.013.365-.045.561-.197a1 1 0 0 0 .386-.76c.008-.249-.099-.449-.172-.57-.074-.123-.178-.265-.286-.413L11.53 6.5l1.424-1.947c.108-.147.213-.29.286-.413.073-.12.18-.321.172-.57a1 1 0 0 0-.386-.76 1.05 1.05 0 0 0-.56-.197c-.143-.013-.32-.013-.503-.013H4.6zm0 1.4v5.4h7.418l-1.44-1.968-.021-.028c-.073-.099-.194-.261-.244-.454a1 1 0 0 1 0-.5c.05-.193.17-.355.244-.453l.021-.03 1.44-1.967z",
    clipRule: "evenodd"
  })));
};
export default SvgIconReport;